module.exports = __webpack_public_path__ + "static/img/103411.0b91d3cc.png";